'use strict';
import {module} from '../app';

module.directive('simplePopover', ['$ionicPopover', function ($ionicPopover) {
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {
        let text = '<ion-popover-view class="simple-popover"><div><div class="item">'
          + attrs.simplePopover
          + '</div></div></ion-popover-view>';

        scope.popover = $ionicPopover.fromTemplate(text);

        el.on('click', function (event) {
          if (scope.v.Value.indexOf('----') == -1) {
            scope.$apply(function () {
              if (scope.popover) {
                scope.popover.show(event);
              }
            });
          }
        });
      }
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/directives/simplePopover.js